import PlacesAutocompleteInputContainer from './PlacesAutocompleteInputContainer';

export default PlacesAutocompleteInputContainer;
